import { useLocation, useNavigate } from 'react-router-dom';

import suporteTecnicoIcon from '@/assets/suporte-tecnico.png';
import { ROUTE_PATHS } from '@/config/constants';
import { Role, useAuth } from '@/contexts/AuthContext';

export function TicketFloatingButton() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const hasTicketAccess =
    user?.role.id === Role.Admin || user?.role.id === Role.Root;

  if (!hasTicketAccess) {
    return null;
  }

  if (
    location.pathname === ROUTE_PATHS.TICKETS ||
    location.pathname === ROUTE_PATHS.ADMIN_TICKETS
  ) {
    return null;
  }

  return (
    <button
      type="button"
      onClick={() => navigate(ROUTE_PATHS.TICKETS)}
      className="fixed bottom-6 right-6 z-40 rounded-full border border-gray-200 bg-white p-3 shadow-sm transition-transform hover:scale-105 hover:bg-gray-50"
      aria-label="Abrir central de tickets"
      title="Abrir suporte"
    >
      <img
        src={suporteTecnicoIcon}
        alt="Suporte técnico"
        className="h-10 w-10"
      />
    </button>
  );
}
